/* eslint-disable react/jsx-props-no-spreading */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cn from 'classnames';
import s from './Header.css';
import Navigation from '../Navigation';
import UserStatus from '../UserStatus';

const messages = defineMessages({
  brand: {
    id: 'header.brand',
    defaultMessage: 'MyBrand',
    description: 'Brand name displayed in header',
  },
  bannerTitle: {
    id: 'header.banner.title',
    defaultMessage: 'Infopages',
    description: 'Title in page header',
  },
});

class Header extends React.Component {
  render() {
    const { user, small } = this.props;
    return (
      <div className={s.framer}>
        <div className={s.sticky}>
          <header className={cn(s.header, small && s.small)}>
            <div className={s.container}>
              {user && <UserStatus />}
              <span className={s.brand}>
                <FormattedMessage {...messages.bannerTitle} />
              </span>
              <div className={s.right}>
                <Navigation small={small} />
              </div>
            </div>
          </header>
        </div>
      </div>
    );
  }
}
Header.propTypes = {
  user: PropTypes.shape({}),
  small: PropTypes.bool.isRequired,
};

Header.defaultProps = {
  user: null,
};

export default withStyles(s)(Header);
